import { render, staticRenderFns } from "./PresentationBoard.vue?vue&type=template&id=d587d024&"
import script from "./PresentationBoard.vue?vue&type=script&lang=js&"
export * from "./PresentationBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports